














































































































































helpers = require('../../helpers.coffee')

view_model = {
  components:
    tag: require('../tags/tag')
    autocomplete: require('../shared/autocomplete/flows')
    lostReasonModal: require('../shared/modals/lost_reason_modal')

  props:
    origem:
      default: null

    contact:
      type: Contact

    initially_selected:
      default: false

    view_mode:
      type: Object
      required: true

    flow:
      type: Flow

  data: ->
    show_flow_search: false
    show_lost_reason_modal: false
    current_user: Session.current_user
    selected: false
    tags_margin_left: if @view_mode.show_checkbox then '77px' else '19px'
    temp_attr: null
    temp_event: null

  computed:
    show_send_to_flow: ->
      ['connected', 'finished', 'inactive', 'not_connected', 'disqualified'].includes?(@contact.recipient_status)

    show_reset_contact: ->
      @view_mode.remove_action == 'remove-from-flow' && @contact.recipient_status != 'uninitialized'

    remove_label: ->
      if @view_mode.remove_action == 'remove-from-flow' then 'Remover do fluxo' else 'Excluir'

    can_change_priority: ->
      if !['inactive', 'finished', 'connected', 'uninitialized', 'blocklisted', 'not_connected', 'disqualified'].includes(@contact.recipient_status)
        return @contact.recipient?.last_flow_action_taken == null
      else if @contact.recipient
        if @contact.recipient.flow_id == @flow?.id
          !['finished', 'connected', 'blocklisted', 'not_connected', 'disqualified'].includes(@contact.recipient_status)
        else
          return true
      else
        true

    overflow_tags: ->
      @contact.tags.length > @view_mode.number_of_tags

    overflow_tags_count: ->
      @contact.tags.length - @view_mode.number_of_tags

    skipped_actions_tooltip_text: ->
      actions = @contact.recipient.metadata.destroyed_tasks.map (step) -> step + 1
      if actions.length > 1
        actions_text = actions.slice(0, -1).join(', ') + " e #{actions.last()}"
        "Etapas #{actions_text} excluídas"
      else
        "Etapa #{actions[0]} excluída"

  watch:
    initially_selected: (new_value, old_value) ->
      @selected = new_value

  methods:
    submit: ->
       @$validator.validateAll({lost_reason_unit: @lost_reason_id}).then (success) =>
         if success
          attr = @temp_attr
          attr['lost_reason'] = { id: @lost_reason_id, comment: @lost_reason_comment }
          @updateContact(@temp_event, attr)

    updateContactInfo: (flow) ->
      @updateStages()
      @removeContactFromList() if @view_mode.show_flow && flow.id != @contact.flow.id
      @contact.flow = flow

    updateStages: ->
      @contact.recipient_status = 'uninitialized'
      @contact.human_recipient_status = 'Não iniciado'
      return unless @contact.stage == 'lost'
      @contact.stage = @contact.previous_stage
      @contact.human_stage = @contact.human_previous_stage

    removeContactFromList: ->
      @$emit 'contact-removed-from-flow', @contact.id

    showFlowSearch: (contact_id) ->
      @show_flow_search = true if @contact.id == contact_id

    showLostReasonModal: ->
      @show_lost_reason_modal = true

    closeLostReasonModal: ->
      @show_lost_reason_modal = false

    hideFlowSearch: ->
      @show_flow_search = false

    toggleSelected: (event) ->
      @selected = !@selected
      @emitSelectionToggleEvent(event)

    emitSelectionToggleEvent: (event = {}, attr = {}) ->
      event.originalEventName = 'contact-selected'
      attr.contact = @contact
      attr.selected = @selected
      @$emit 'contact-selected', { event, attr }

    openContact: ->
      return unless @view_mode.name_go_to_show && @contact.id
      if @view_mode.link_open_bar
        event.originalEventName = 'toggle-task-bar'
        @$emit 'toggle-task-bar', { event, @contact }
      else
        @viewContact()

    viewContact: ->
      return unless @view_mode.name_go_to_show && @contact.id
      @$router.push path: @contactPath()

    contactPath: ->
      "/contatos/#{@contact.id}"

    updateLostContact: (lost_reason) ->
      attr = @temp_attr
      attr['lost_reason_id'] = lost_reason.id
      attr['lost_reason_comment'] = lost_reason.comment
      attr['send_to_new_flow'] = lost_reason.send_to_new_flow
      attr['due_on_date_custom'] = lost_reason.due_on_date_custom
      attr['flow'] = lost_reason.flow
      attr['immediately'] = lost_reason.immediately
      attr['stage'] = lost_reason.stage if lost_reason.stage
      attr['status'] = lost_reason.status if lost_reason.status
      attr['schedule_set_contact_stage'] = lost_reason.schedule_set_contact_stage if lost_reason.schedule_set_contact_stage
      @updateContact(@temp_event, attr)
      @show_lost_reason_modal = false


    updateContact: (event, attr) ->
      origin = @getOrigin()
      IntercomCtrl.trackEvent("#{origin} - Mudança de estágio para #{attr['stage']}" )
      event.originalEventName = 'contact-update'
      attr.id = @contact.id
      @$emit 'contact-update', { event, attr }

    setLostInfo: (event, attr) ->
      if attr.stage == 'lost'
        @temp_attr = attr
        @temp_event = event
        @show_lost_reason_modal = true
      else
        @updateContact(event, attr)


    getOrigin: ->
      if @flow
        "Fluxo de cadência"
      else if location.href.indexOf('tarefas') > -1
        "Contatos pausados"
      else
        "Base de contatos"

    updateContactRecipient: (event, attr) ->
      event.originalEventName = 'contact-recipient-update'
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @temp_event = event
      if attr.status == 'blocklisted'
        return @show_lost_reason_modal = true
      @$emit 'contact-recipient-update', { event, attr }

    connectedAndSendToNewFlow: (event) ->
      return if @show_lost_reason_modal == true
      event.stopPropagation()
      attr = { status: 'connected', event: 'send_to_new_flow' }
      event.originalEventName = 'contact-recipient-update'
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @temp_event = event
      @$emit 'contact-recipient-update', { event, attr }
      @show_lost_reason_modal = true

    connectedAndLost: (event) ->
      event.stopPropagation()
      attr = { status: 'connected', event: 'lost' }
      event.originalEventName = 'contact-recipient-update'
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @temp_event = event
      # @$emit 'contact-recipient-update', { event, attr }
      @temp_attr = { stage: 'lost', status: 'lost', new_status: 'connected' }
      @show_lost_reason_modal = true

    connectedAndCreateTask: (event) ->
      event.stopPropagation()
      attr = { status: 'connected' }
      event.originalEventName = 'contact-recipient-update'
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @temp_event = event
      @$emit 'contact-recipient-update', { event, attr }
      EventsBus.$emit 'TaskModalForm::Show', { task_id: null, contact: @contact, id: 'manual-task-form-modal', show_stage_selection: true }

    connectedAndChangeStage: (event) ->
      event.stopPropagation()
      attr = { status: 'connected', event: 'change_stage' }
      event.originalEventName = 'contact-recipient-update'
      attr.contact_id = @contact.id
      attr.id = @contact.recipient.id
      @temp_attr = attr
      @temp_event = event
      @$emit 'contact-recipient-update', { event, attr }
      @show_lost_reason_modal = true

    checkboxSelectContact: (event) ->
      return if @view_mode.anywhere_select
      @toggleSelected(event)

    anywhereSelectContact: (event) ->
      return unless @view_mode.anywhere_select
      if @view_mode.anywhere_select_action == 'check'
        @toggleSelected(event)
      else if @view_mode.anywhere_select_action == 'emit-selected'
        data = { contact: @contact, event: { originalEventName: 'contact-selected' } }
        @$emit('contact-selected', data)

    selectedItem: (data) ->
      @selected = data.selected_page || data.selected_all
      @emitSelectionToggleEvent()

    editContact: (event, attr = {}) ->
      event.originalEventName = 'contact-edit'
      @$emit 'contact-edit', { event, @contact }

    destroyContact: (event, attr = {}) ->
      event.originalEventName = 'contact-destroy'
      @$emit 'contact-destroy', { event, @contact }

    resetContactRecipient: (event, attr = {}) ->
      event.originalEventName = 'contact-recipient-reset'
      @$emit 'contact-recipient-reset', { event, @contact }

    lastEmailOpenEventAt: ->
      time = moment(@contact.recipient.emailOpenStatistics().last_at).format('LLL')
      "Ultima abertura: #{time}"

    showEmailOpenStatisticBadge: ->
      @contact.recipient.emailOpenStatistics() && @contact.recipient.emailOpenStatistics().count > 1 &&
       @contact.recipient_last_flow_action_taken_state == 'open'

    canUpdateContact: ->
      @current_user.isAdmin() || @current_user.isManager() || @contact.user.id == @current_user.id

    canScheduleReactivation: ->
      return false if @current_user.isMonitoringManager()
      @contact.recipient and (@contact.recipient_status == 'paused' or @contact.recipient_status == 'scheduled_reactivation')

    openRecipientScheduleReactivationModal: (event) ->
      attr = { contact: @contact }
      EventsBus.$emit 'Contact::ScheduleRecipientReactivation', { event, attr }

    scheduleReactivationText: ->
      if @contact.recipient and @contact.recipient.reactivate_automatic_task.constructor == Task
        'Editar Reativação'
      else
        'Agendar Reativação'

  created: ->
    EventsBus.$on 'ContactList:SelectedAll', @selectedItem
    EventsBus.$on 'ContactList:SelectedPage', @selectedItem
    EventsBus.$on 'open-flow-search', @showFlowSearch
    @selected = @initially_selected

  beforeDestroy: ->
    EventsBus.$off 'ContactList:SelectedAll', @selectedItem
    EventsBus.$off 'ContactList:SelectedPage', @selectedItem
    EventsBus.$off 'open-flow-search', @showFlowSearch

  mounted: ->
    Tooltip.initialize()
}

exports.default = helpers.vue_include(view_model, helpers.contacts.styles, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/list_item.vue